<template>
  <v-layout wrap>
    <v-flex xs12>
      <h2 class="mb-4">
        {{ $t('step_message.title') }}
        <a href="https://blog.zwiz.app/feature-audience/" target="blank" class="primary--text">
          <i style="font-size: 22px" class="fas fa-question-circle"> </i>
        </a>
      </h2>
    </v-flex>
    <v-flex xs12 sm6 md8></v-flex>
    <v-flex xs12 sm6 md4 style="display: inherit">
      <v-text-field
        v-model="search"
        :placeholder="$t('step_message.search')"
        hide-details
        clearable
        outline
        single-line
        @click:clear="clearSearch()"
      ></v-text-field>
      <v-btn color="primary" @click="searchAudience()">
        {{ $t('Search') }}
      </v-btn>
    </v-flex>
    <v-flex xs12 class="my-4">
      <div
        class="add-conversation text-xs-center"
        :class="{ disabled: pageConfig.total >= maxAudience }"
        style="cursor: pointer"
        @click="createAudience()"
      >
        <i class="fa fa-plus middle"></i>
        {{ $t('step_message.create') }} ( {{ pageConfig.total }} / {{ maxAudience }} )
      </div>
    </v-flex>
    <!-- <v-flex xs12 sm6 v-if="audiences.length"></v-flex>
    <v-flex xs12 sm6 class="d-flex justify-content-end mb-4" v-if="audiences.length">
      <v-pagination v-model="pageConfig.page" @input="() => {}" :length="10"></v-pagination>
    </v-flex> -->
    <template v-if="audiences.length">
      <v-flex v-for="(audience, index) in audiences" :key="`audience-${index}`" xs12>
        <audience-card
          class="mb-4"
          :value="audience"
          :total="pageConfig.total"
          :max="maxAudience"
          @copy:success="refresh"
          @delete:success="refresh"
          @send:success="refresh"
          @edit="editAudience"
        />
      </v-flex>
    </template>
    <template v-else>
      <v-flex xs12 class="text-xs-center" style="margin: 64px 0">
        {{ $t('step_message.no_available') }}
      </v-flex>
    </template>
    <!-- <v-flex xs12 sm6 v-if="audiences.length"></v-flex>
    <v-flex xs12 sm6 class="d-flex justify-content-end mt-4" v-if="audiences.length">
      <v-pagination v-model="pageConfig.page" @input="() => {}" :length="10"></v-pagination>
    </v-flex> -->
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import AudienceCard from './AudienceCard.vue'
import { setTagValue } from '@/utils/tags'
import audienceApi from '@/api/audience'
export default {
  components: { AudienceCard },
  props: {
    step: {
      type: String
    }
  },
  data: () => ({
    search: '',
    pageConfig: {
      page: 1,
      pageNumber: 1,
      total: 0,
      pageCount: 1,
      limit: 20
    },
    audiences: [],
    maxAudience: 15,
    isSearch: false,
    deletedIds: []
  }),
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    stepType: {
      get() {
        return this.step
      },
      set(value) {
        this.$emit('update:step', value)
      }
    }
  },
  async created() {
    this.$store.dispatch('loading')
    await new Promise((resolve) => setTimeout(resolve, 500))
    this.fetchAudience()
    this.$store.dispatch('loading')
  },
  methods: {
    async fetchAudience() {
      try {
        const response = await audienceApi.getAudiences({
          page_id: this.selectedBot.pageid,
          limit: this.pageConfig.limit,
          offset: (this.pageConfig.page - 1) * this.pageConfig.limit,
          name: this.search
        })
        if (response.status === 200) {
          const audiences = response.data.audience
            ? response.data.audience.filter((item) => !this.deletedIds.includes(item.id))
            : []
          const total = response.data.total_all_audience
            ? response.data.total_all_audience - (response.data.audience.length - audiences.length)
            : response.data.total_all_audience
          this.audiences = audiences
          this.pageConfig.total = total || 0
          this.pageConfig.pageCount = Math.ceil(this.pageConfig.total / this.pageConfig.limit)
          this.$emit('update:total', this.pageConfig.total)
        }
      } catch (error) {}
    },
    async clearSearch() {
      if (!this.isSearch) return
      this.isSearch = false
      await this.refresh()
    },
    async searchAudience() {
      this.isSearch = true
      await this.refresh()
    },
    async createAudience() {
      if (this.pageConfig.total >= this.maxAudience) {
        await this.$swal.fire({
          title: this.$t('Warning!'),
          text: this.$t('step_message.limit_reached'),
          type: 'warning',
          confirmButtonText: this.$t('Confirm'),
          reverseButtons: true
        })
      } else {
        this.stepType = 'form'
      }
    },
    async refresh(id = null) {
      this.$store.dispatch('loading')
      await new Promise((resolve) => setTimeout(resolve, 1500))
      this.audiences = []
      if (id) {
        this.deletedIds.push(id)
      }
      await this.fetchAudience()
      this.$store.dispatch('loading')
    },
    editAudience(id) {
      const audience = this.audiences.find((item) => item.id === id)
      if (audience) {
        const initTagComplete =
          audience.init_options && audience.init_options.total_completed_verify_slip
            ? [setTagValue('complete', audience.init_options.total_completed_verify_slip)]
            : []

        const initTagMoreThan =
          audience.init_options && audience.init_options.total_completed_verify_slip_more_than
            ? [setTagValue('more', audience.init_options.total_completed_verify_slip_more_than)]
            : []

        const addTagComplete =
          audience && audience.tag_target_group_add_total_completed_verify_slip
            ? [setTagValue('complete', audience.tag_target_group_add_total_completed_verify_slip)]
            : []

        const addTagMoreThan =
          audience && audience.tag_target_group_add_total_completed_verify_slip_more_than
            ? [
                setTagValue(
                  'more',
                  audience.tag_target_group_add_total_completed_verify_slip_more_than
                )
              ]
            : []

        const removeTagComplete =
          audience && audience.tag_target_group_remove_total_completed_verify_slip
            ? [
                setTagValue(
                  'complete',
                  audience.tag_target_group_remove_total_completed_verify_slip
                )
              ]
            : []

        const removeTagMoreThan =
          audience && audience.tag_target_group_remove_total_completed_verify_slip_more_than
            ? [
                setTagValue(
                  'more',
                  audience.tag_target_group_remove_total_completed_verify_slip_more_than
                )
              ]
            : []

        const payload = {
          id: audience.id,
          name: audience.name,
          init_type: audience.init_type || null,
          init_data: audience.init_data
            ? [...initTagComplete, ...initTagMoreThan, ...audience.init_data]
            : [],
          init_options: {
            file_name:
              audience.init_options && audience.init_options.file_name
                ? audience.init_options.file_name
                : ''
          },
          tag_target_group_add_type: audience.tag_target_group_add_type,
          tag_target_group_add_data: [
            ...addTagComplete,
            ...addTagMoreThan,
            ...audience.tag_target_group_add_data
          ],
          tag_target_group_add_add_tag: audience.tag_target_group_add_add_tag,
          tag_target_group_add_remove_tag: audience.tag_target_group_add_remove_tag,
          tag_target_group_remove_type: audience.tag_target_group_remove_type,
          tag_target_group_remove_data: [
            ...removeTagComplete,
            ...removeTagMoreThan,
            ...audience.tag_target_group_remove_data
          ],
          tag_target_group_remove_add_tag: audience.tag_target_group_remove_add_tag,
          tag_target_group_remove_remove_tag: audience.tag_target_group_remove_remove_tag,
          is_allowed_broadcast: audience.is_allowed_broadcast || false,
          is_enabled_auto_upload_line: audience.is_enabled_auto_upload_line || false,
          is_enabled_auto_upload_line_step_message:
            audience.is_enabled_auto_upload_line_step_message || false,
          is_enabled_auto_upload_facebook: audience.is_enabled_auto_upload_facebook || false
        }

        this.$emit('edit', payload)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/stepmessage/AudienceLists.vue